import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=9b2e6594&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"
import style0 from "./Modify.vue?vue&type=style&index=0&id=9b2e6594&lang=less&scoped=true&"
import style1 from "./Modify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2e6594",
  null
  
)

export default component.exports